import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React from 'react'
import {useAdditionalItemsToggle} from '../../../hooks/use-additional-items-toggle'
import s from './card-container.scss'
import {CardContainerProps} from './interfaces'

export const CardContainer = ({event, children, lastItem, applyPadding = false}: CardContainerProps) => {
  const {hovered, events} = useAdditionalItemsToggle({event})

  return (
    <li
      {...events}
      data-hook={DH.listItem}
      className={classNames(s.container, {[s.last]: lastItem, [s.padding]: applyPadding})}
    >
      {children(hovered)}
    </li>
  )
}
